<template>
  <main-layout v-if="wave">
    <template slot="header-title">{{ wave.name }}</template>
    <template slot="header-actions">
      <common-button type="secondary">
        <router-link class="text-gray-600" :to="{ name: 'Waves', params: { site: site.sitekey } }">Cancel</router-link>
      </common-button>
      <common-button @click="save()">Save </common-button>
    </template>

    <template slot="main">
      <common-ui-form-general
        v-if="wave"
        type="wave"
        :code="wave.code"
        :name="wave.name"
        :status="wave.status"
        :activationdate="wave.activationdate"
        :deactivationdate="wave.deactivationdate"
        :csvFields="wave.csvFields"
        :importCsv="importCsv"
        :isCsv="wave.iscsv === 1"
        :loading="loading"
        @update-name="name => (fields.name = name)"
        @update-status="status => (fields.status = status)"
        @update-activationdate="dateStart => updateDateStart(dateStart)"
        @update-deactivationdate="dateEnd => updateDateEnd(dateEnd)"
        @update-csv-import="csvFile => (importCsv = csvFile)"
        @upload-csv-file="uploadCsvFile"
      />

      <waves-ui-form-step-list
        :wave-id="id"
        :steps="fields.steps"
        :viewsSteps="viewsSteps"
        :csvFields="fields.csvFields"
        @created-step="
          step => {
            fields.steps.push(step)
          }
        "
        @updated-step="updateStep"
        @updated-order="
          steps => {
            fields.steps = [...steps]
          }
        "
        @deleted-step="
          index => {
            fields.steps.splice(index, 1)
          }
        "
      />

      <waves-ui-form-last-step
        v-if="wave"
        :key="lastStepKey"
        type="wave"
        :data="wave"
        @update-lastStepUrl="newLink => (fields.lastStepUrl = newLink)"
        @update-lastStepText="newText => (fields.lastStepText = newText)"
        @update-openinnewtab="openinnewtab => (fields.openinnewtab = openinnewtab)"
      />

      <common-ui-form-trigger
        v-if="wave"
        type="wave"
        :data="wave"
        @update-frequencylimitationvalue="
          newfrequencylimitationvalue =>
            (fields.frequencylimitationvalue = newfrequencylimitationvalue)
        "
        @update-frequencylimitation="
          newFrequencylimitation =>
            (fields.frequencylimitation = newFrequencylimitation)
        "
        @update-frequency="newFrequency => (frequency = newFrequency)"
      />

      <common-ui-form-targeting
        v-if="wave"
        type="Wave"
        :current-url="wave.url"
        :target-url="wave.url_target"
        :target-url-list="wave.url_target_list"
        :exclude-url="wave.url_exclude_list"
        @update-fields-url="url => (fields.url = url)"
        @update-path-target="urlTarget => (fields.url_target_list = urlTarget)"
        @update-path-exclude="urlExclude => (fields.url_exclude_list = urlExclude)"
      />

      <common-ui-form-audience
        v-if="wave.target_audience && wave.bubbles"
        :key="audienceKey"
        type="wave"
        :isCsv="wave.iscsv === 1"
        :target-audience="wave.target_audience"
        :excluded-audience="wave.excluded_audience"
        :bubbles="wave.bubbles"
        :excluded-bubbles="wave.excluded_bubbles"
        @update-audience="audienceData => (fields.target_audience = audienceData)"
        @update-excluded-audience="audienceData => (fields.excluded_audience = audienceData)"
        @update-bubbles="bubble => updateFieldsBubble(bubble)"
        @update-excluded-bubbles="bubble => updateFieldsExcludedBubble(bubble)"
        @erase-bubble="bubbles => (fields.bubbles = bubbles)"
        @erase-excluded-bubble="bubbles => (fields.excluded_bubbles = bubbles)"
      />

      <template>
        <div style="position: fixed; bottom: 20px; left: 20px; margin: 0; z-index: 9999;">
          <common-ui-alert
            type="warning"
            message="You have modification not saved. Don't forget to save it."
            :base="wave"
            :object="fields"
          />
        </div>
      </template>

      <modal-confirmation
        v-if="modals.isOpenDeletionConfirmation"
        :open="modals.isOpenDeletionConfirmation"
        type="danger"
        messageTitle="Warnings !"
        message="Do you really want to remove this wave ? This actions cannot be undone."
        messageAction="Yes, I'm sure !"
        @execute="remove"
        @close="modals.isOpenDeletionConfirmation = false"
      />
    </template>
  </main-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueDropdown from '@kevindesousa/vue-dropdown'
import Empty from '@/components/box-entity-empty.vue'
import ModalConfirmation from '@/components/others/utils/ModalConfirmation.vue'
import ModalMultipleChoices from '@/components/others/utils/ModalMultipleChoices.vue'

export default {
  name: 'Wave',
  components: {
    VueDropdown,
    Empty,
    ModalConfirmation,
    ModalMultipleChoices
  },

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      viewsSteps: [],
      isClosed: false,
      loaded: false,
      pendingStep: false,
      modals: {
        isOpenFormLinkEvent: false,
        isOpenDeletionConfirmation: false,
        isOpenMultipleChoices: false
      },
      fieldsError: {
        name: null,
        url: null,
        date: null
      },
      fields: {
        // badge: null,
        id: null,
        code: null,
        name: null,
        url: null,
        frequencylimitation: null,
        frequencylimitationvalue: null,
        url_target: null,
        activationdate: null,
        deactivationdate: null,
        target_audience: null,
        excluded_audience: null,
        redirection_url: null,
        status: null,
        steps: [],
        bubbles: [],
        excluded_bubbles: [],
        lastStepUrl: null,
        lastStepText: null,
        url_target_list: [],
        url_exclude_list: [],
        csvFields: [],
        iscsv: 0,
        openinnewtab: false
      },
      inputs: {
        redirectionUrl: null,
        targetAll: false,
        event: false
      },
      extra: {
        campaigns: null
      },
      importCsv: null,
      loading: false,
      lastStepKey: 1234,
      audienceKey: 4321
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    ...mapGetters('waves', {
      getById: 'getById'
    }),

    languages() {
      return this.site.languages.map(lang => lang.lang)
    },

    wave() {
      return this.getById(this.id)
    }
  },

  watch: {
    site: {
      handler: 'initWave',
      immediate: true
    }
  },

  methods: {
    ...mapActions('waves', ['loadWave', 'getStepStats', 'updateWave', 'removeWave', 'updateCsvFile']),
    ...mapActions('campaigns', ['loadCampaign']),

    initWave() {
      if (this.site) {
        // 1. Load the wave
        this.loadWave({ id: this.id })
          .catch(() => {
            this.$notify.error({
              title: 'Error',
              message: 'An error has occurred'
            })
          })
          .then(wave => {
            this.getStepStats({ id: this.id }).then(data => {
              for (var result in data.results.steps) {
                this.viewsSteps.push(data.results.steps[result])
              }
            })
            this.updateFields(wave)
            if (wave.csvFields.length > 0) {
              this.csvWave = true
            }
          })
      }
    },

    updateFieldsBubble(bubble) {
      const indexBubble = this.fields.bubbles.findIndex(b => b.id === bubble.id)
      const bubbleExist = indexBubble !== -1
      if (bubbleExist) {
        this.fields.bubbles.splice(indexBubble, 1)
      }

      this.fields.bubbles.push(bubble)
    },

    updateFieldsExcludedBubble(bubble) {
      const indexBubble = this.fields.excluded_bubbles.findIndex(b => b.id === bubble.id)
      const bubbleExist = indexBubble !== -1
      if (bubbleExist) {
        this.fields.excluded_bubbles.splice(indexBubble, 1)
      }

      this.fields.excluded_bubbles.push(bubble)
    },

    checkInputs() {
      const ValidHostnameRegex = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/

      let error = false

      if (!this.fields.name) {
        this.fieldsError.name = 'Name must be a valid string, like: Welcome dear !'
        error = true
      }

      if (
        !this.fields.url ||
        !Array.isArray(this.fields.url.match(ValidHostnameRegex)) ||
        (Array.isArray(this.fields.url.match(ValidHostnameRegex)) && !this.fields.url.match(ValidHostnameRegex).length)
      ) {
        this.fieldsError.url = 'Hostname must be a valid string, like: rocketfid.com'
        error = true
      }

      this.fields.steps.forEach((step, index) => {
        for (var [lang, body] of Object.entries(step.body)) {
          if (body === '') {
            delete this.fields.steps[index].body[lang]
          }
        }
      })

      return !error
    },
    updateStep(step) {
      this.fields.steps[step.index] = step
    },
    async save() {
      this.fieldsError.name = null
      this.fieldsError.url = null
      this.fieldsError.date = null

      if (this.fields.target_audience === 'all') {
        this.fields.bubbles = []
      }

      if (this.fields.excluded_audience === 'no-one') {
        this.fields.excluded_bubbles = []
      }

      if (!this.checkInputs()) {
        return false
      }

      let wave = await this.updateWave({
        wave: { ...this.fields, id: this.id },
        sitekey: this.$route.params.site
      }).catch(() => {
        this.$notify.error({ title: 'Error', message: 'An error has occurred' })
      })
      this.updateFields(wave)
      this.lastStepKey = this.getRandomKey()
      this.pendingStep = false
      this.$notify({ title: 'Success', message: 'Wave updated with success' })
    },
    updateDateStart(ds) {
      this.fields.activationdate = ds
    },

    updateDateEnd(de) {
      this.fields.deactivationdate = de
    },
    updateFields(wave) {
      this.fields = Object.assign({}, wave)
      if (this.fields.url_target === '.*') {
        this.inputs.targetAll = true
      }

      if (this.fields.redirection_url) {
        this.inputs.redirectionUrl = true
      }
      setTimeout(() => {
        this.loaded = true
      }, 500)
    },

    remove() {
      this.removeWave({ wave: { id: this.id } })
        .then(() => {
          this.$notify({
            title: 'Success',
            message: this.$root.$t('notifications.wave.deleted'),
            type: 'success'
          })
          this.$router.push(`/${this.site.sitekey}/waves/`)
        })
        .catch(response => {
          this.$notify.error({
            title: this.$root.$t('api.' + response.data.code + '.title'),
            message: this.$root.$t('api.' + response.data.code + '.message')
          })
        })
    },

    async uploadCsvFile() {
      if (this.importCsv) {
        this.loading = true
        /** upload csv file */
        let waveBeforeUploadCsv = { ...this.fields, id: this.id }
        let waveAfterUploadCsv = await this.updateCsvFile({
          wave: waveBeforeUploadCsv,
          csvFile: this.importCsv,
          sitekey: this.$route.params.site
        }).catch(response => {
          let message =
            response.response && response.response.data && response.response.data.error
              ? response.response.data.error
              : 'An error occurred while importing the csv file'
          this.$notify({
            title: 'Error',
            message: message,
            type: 'error'
          })
          this.importCsv = null
          this.loading = false
          throw response
        })

        /** only change things related to the upload of csv */
        let lastStepUrlCondition =
          waveAfterUploadCsv.lastStepUrl === '[[last_step_url]]' ||
          waveBeforeUploadCsv.lastStepUrl === '[[last_step_url]]'
        let newWave = {
          ...waveBeforeUploadCsv,
          csvFields: waveAfterUploadCsv.csvFields,
          lastStepUrl: lastStepUrlCondition ? waveAfterUploadCsv.lastStepUrl : waveBeforeUploadCsv.lastStepUrl,
          bubbles: waveAfterUploadCsv.bubbles
        }

        this.updateFields(newWave)

        let wave = await this.updateWave({
          wave: { ...this.fields, id: this.id },
          sitekey: this.$route.params.site
        }).catch(() => {
          this.$notify.error({
            title: 'Error',
            message: 'An error has occurred'
          })
        })
        this.updateFields(wave)
        this.pendingStep = false
        this.$notify({ title: 'Success', message: 'Wave updated with success' })

        this.importCsv = null
        /** reload wave */
        this.audienceKey = this.getRandomKey()
        this.lastStepKey = this.getRandomKey()
      }
      this.loading = false
    },
    getRandomKey() {
      return Math.floor(Math.random() * 10000)
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isSameObject(this.fields, this.wave)) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  mounted() {
    if (this.$route.query.add_step === '1') {
      this.modals.isOpenFormNewWaveStep = true
    }

    this.loadCampaign()
      .then(campaigns => {
        this.extra.campaigns = campaigns
      })
      .catch(error => console.error(error))

    // this.loadBadges()
    //   .then(badges => {
    //     this.extra.badges = badges
    //   })
    //   .catch(error => console.error(error))
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Wave/Wave.vue